import { Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, MenuItem, Select, Stack, Tooltip, Typography, useTheme } from '@mui/material'
import React from 'react'
import { currencySymbol, ordersFilterConfigs, statusConfigs, statusOptions } from 'utils/constant';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { formatCurrency, formatDate, formattedDateTime, getUTCDateTime, utcTimeToLocal } from 'utils/function';
import "./style.css";
import { useSelector } from 'react-redux';
import orderItems from "assests/orderItems.svg";
import calender from "assests/calender.svg";
import table from "assests/table.svg";
import groupUsers from "assests/groupUser.svg";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const ViewOrderDialogcontainer = ({ viewOrderData, open, onClose, handleStatusChange, totalItemCount, handleOpenDialog, loader, handleStatusWithChefCheck, handleCompleteFlow, handleDetails, handleStatusWithRiderCheck }) => {
    const theme = useTheme();
    const utcTime = utcTimeToLocal(viewOrderData?.booking_time, viewOrderData?.booking_date);
    const userData = useSelector((state) => state?.posData);
    const cfg = ordersFilterConfigs.find((f) => f.id === viewOrderData?.order_type) || {
        label: viewOrderData?.order_type,
    };
    const current = viewOrderData?.order_status;
    const flow = statusOptions[viewOrderData?.order_type] || [];
    let next = flow[current] ? [...flow[current]] : [];

    const isPaid = viewOrderData?.payment_status === "paid" ||
        (viewOrderData?.paid_amount && viewOrderData?.total_amount && parseFloat(viewOrderData?.paid_amount) >= parseFloat(viewOrderData?.total_amount));

    if (viewOrderData?.order_type === 'delivery' && isPaid) {
        if (current === 'out_for_delivery') {
            next = ['completed'];
        }
    }

    const isStatusLocked = viewOrderData?.order_status === "accept" && viewOrderData?.orderItems?.length === 0;
    return (
        <>
            <DialogTitle className='view-order' sx={{ px: 5, pt: 3, pb: 2 }}>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Box className='d-flex align-items-start' sx={{ flexDirection: 'column' }}>
                        <Typography variant="h6" className='order-type-title'>
                            {cfg?.label} Order
                        </Typography>
                        <Typography variant='body2' sx={{ fontWeight: '500' }}>
                            #{viewOrderData?.order_id}
                        </Typography>
                    </Box>
                    {viewOrderData?.order_status == "cancel" || viewOrderData?.order_status == "reject" || viewOrderData?.order_status == "completed" ?
                        <Box className='d-flex align-items-center' sx={{ height: '100%' }}>
                            <Typography variant='body2' sx={{ padding: '0px 10px', alignContent: 'center', lineHeight: '1.5', backgroundColor: statusConfigs[current].bg, color: '#000', borderRadius: '8px', fontWeight: '600', width: '140px', height: '31px', fontSize: '13px' }}>
                                {viewOrderData?.order_type === 'delivery' && isPaid && current === 'completed' ? 'Delivered & Completed' : statusConfigs[current].label}
                            </Typography>
                        </Box>
                        :
                        <Select
                            value={current}
                            size="small"

                            // IconComponent={ArrowDropDownIcon}
                            IconComponent={
                                loader ?
                                    () => <CircularProgress size={16} sx={{ color: '#000', position: 'absolute', right: '7px' }} />
                                    : ArrowDropDownIcon
                            }
                            renderValue={() => {
                                if (viewOrderData?.order_type === 'delivery' && isPaid && current === 'completed') {
                                    return "Delivered & Completed";
                                }
                                return statusConfigs[current]?.label;
                            }}
                            // onChange={(e) => {
                            //     const chosen = e.target.value;
                            //     if (['cancel', 'reject'].includes(chosen)) {
                            //         // only show confirmation for cancel/reject
                            //         handleOpenDialog(viewOrderData, chosen);
                            //     } else {
                            //         // immediate change for other statuses
                            //         handleStatusChange(viewOrderData, chosen);
                            //     }
                            // }}
                            disabled={isStatusLocked}
                            onChange={(e) => {
                                const chosen = e.target.value;
                                if (['cancel', 'reject'].includes(chosen)) {
                                    handleOpenDialog(viewOrderData, chosen);
                                } else if (chosen === "completed") {
                                    handleCompleteFlow(viewOrderData);
                                } else {
                                    handleStatusWithRiderCheck(viewOrderData, chosen);
                                }
                            }}
                            // onChange={(e) => {
                            //     const chosen = e.target.value;
                            //     if (['cancel', 'reject'].includes(chosen)) {
                            //         handleOpenDialog(viewOrderData, chosen);
                            //     } else {
                            //         // Check for items needing chef selection
                            //         const itemsNeedingChef = (viewOrderData?.orderItems || []).filter(
                            //             item => item.stationData?.chefs?.length > 1 && !item.primary_chef_id
                            //         );

                            //         if (chosen === "preparing" && itemsNeedingChef?.length > 0) {
                            //             // Open Assign Chef modal
                            //             setAssignChefData({
                            //                 orderId: viewOrderData?.id,
                            //                 items: itemsNeedingChef
                            //             });

                            //             // Default first chef selection
                            //             const selections = {};
                            //             itemsNeedingChef.forEach(item => {
                            //                 selections[item.id] = item.stationData.chefs[0].id;
                            //             });
                            //             setAssignChefSelections(selections);
                            //             setPendingStatus(chosen);
                            //             setAssignChefOpen(true);
                            //         } else {
                            //             handleStatusChange(viewOrderData, chosen);
                            //         }
                            //     }
                            // }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    backgroundColor: statusConfigs[current]?.bg,
                                    color: '#000',
                                    borderRadius: '8px',
                                    '& fieldset': { border: 'none' },
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: "none !important",
                                    borderColor: 'transparent !important'
                                },
                                '& .MuiSelect-select': {
                                    py: '4px', px: '8px',
                                    textTransform: 'none',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    backgroundColor: statusConfigs[current]?.bg,
                                    color: '#000'
                                },
                                '& .MuiSelect-icon': {
                                    color: '#000',
                                },
                                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    border: 'none !important',
                                    borderColor: 'transparent !important'
                                },
                                // remove the default focus ring / box-shadow
                                '& .MuiOutlinedInput-root.Mui-focused': {
                                    outline: 'none !important',
                                    boxShadow: 'none !important',
                                    borderColor: 'transparent !important',
                                    border: 'none !important'
                                },
                                width: 150,
                            }}
                            MenuProps={{
                                PaperProps: { sx: { mt: 1, width: "170px" } },
                            }}
                        >
                            {next?.map(statusKey => {
                                let optionLabel = statusConfigs[statusKey]?.optionLabel;
                                if (viewOrderData?.order_type === 'delivery' && isPaid && statusKey === 'completed') {
                                    optionLabel = "Delivered & Completed";
                                }
                                return (
                                    <MenuItem
                                        key={statusKey}
                                        value={statusKey}
                                        sx={{ textTransform: 'none', fontSize: '14px' }}
                                    >
                                        {optionLabel}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    }
                </Grid>
            </DialogTitle>
            <Divider />

            {/* Content */}
            <DialogContent sx={{ px: 5, pt: 2, pb: 1 }}>
                {/* Customer */}
                <Grid container className='listing-view-order'>
                    <Typography variant="body2" className='listing-title'>Customer</Typography>
                    <Typography variant="body2" className='listing-details' sx={{ textAlign: 'end' }}>
                        {viewOrderData?.customerVendor?.customer_full_name || viewOrderData?.customer_name || '-'}
                        {Boolean(viewOrderData?.customerVendor?.customerInfo?.phone || viewOrderData?.customer_mobile) && (
                            <>
                                <br />
                                {viewOrderData?.customerVendor?.customerInfo?.country_code} {viewOrderData?.customerVendor?.customerInfo?.phone || viewOrderData?.customer_mobile}
                            </>
                        )}
                    </Typography>
                </Grid>
                <Divider className='divider-view-details' />

                {/* Delivery Address */}
                {viewOrderData?.order_type == "delivery" && viewOrderData?.orderAddress &&
                    <>
                        <Grid container className='listing-view-order'>
                            <Typography variant="body2" className='listing-title'>Delivery Address</Typography>
                            <Box sx={{ maxWidth: '200px', textAlign: 'end' }}>
                                <Typography variant="body2" className='listing-details'>
                                    {/* 504, New Target Apt., Near Type-C Tower, Bhulabhai, Ahmedabad - 380008 */}
                                    {/* {viewOrderData?.orderAddress?.address, viewOrderData?.landmark ? viewOrderData?.landmark : '', viewOrderData?.locality?viewOrderData?.locality: '',viewOrderData?.city ? viewOrderData?.city : '', viewOrderData?.zipcode ? viewOrderData?.zipcode: '' } */}
                                    {[
                                        viewOrderData?.orderAddress?.address,
                                        viewOrderData?.orderAddress?.landmark,
                                        viewOrderData?.orderAddress?.locality,
                                        viewOrderData?.orderAddress?.city,
                                        viewOrderData?.orderAddress?.zipcode
                                    ]
                                        .filter(Boolean)
                                        .join(', ')}
                                </Typography>
                            </Box>
                        </Grid>
                        <Divider className='divider-view-details' />
                    </>
                }

                {/* Rider Info */}
                {viewOrderData?.riderInfo && (
                    <>
                        <Grid container className='listing-view-order'>
                            <Typography variant="body2" className='listing-title'>Rider</Typography>
                            <Typography variant="body2" className='listing-details' sx={{ textAlign: 'end' }}>
                                {viewOrderData?.riderInfo?.full_name}
                                <br />
                                +{viewOrderData?.riderInfo?.country_code} {viewOrderData?.riderInfo?.phone}
                            </Typography>
                        </Grid>
                        <Divider className='divider-view-details' />
                    </>
                )}

                {/* Ordered at */}
                <Grid container className='listing-view-order'>
                    <Typography variant="body2" className='listing-title'>Ordered at</Typography>
                    <Box display="flex" alignItems="center">
                        <Typography variant="body2" className='listing-details'>
                            {formattedDateTime(viewOrderData?.created_at)}
                        </Typography>
                    </Box>
                </Grid>
                <Divider className='divider-view-details' />

                {/* Scheduled For */}
                {viewOrderData?.order_type == "booking" ?
                    <>
                        <Grid container className='listing-view-order'>
                            <Typography variant="body2" className='listing-title'>Scheduled for</Typography>
                            <Box display="flex" alignItems="center">
                                <img src={calender} alt='calender' className='orderItem-img' />
                                <Typography variant="body2" className='listing-details'>
                                    {formatDate(viewOrderData?.booking_date)}, {utcTime}
                                </Typography>
                            </Box>
                        </Grid>
                        <Divider className='divider-view-details' />
                    </> : ''
                }

                {/* No.Of People & Table */}
                {(viewOrderData?.order_type === "dine_in" || viewOrderData?.order_type === "booking") ?
                    <>
                        <Grid container className='listing-view-order'>
                            <Typography variant="body2" className='listing-title'>No. of people</Typography>
                            <Box display="flex" alignItems="center">
                                <img src={groupUsers} alt='users' className='orderItem-img' />
                                <Typography variant="body2" className='listing-details'>
                                    {viewOrderData?.guest_count}
                                </Typography>
                            </Box>
                        </Grid>
                        <Divider className='divider-view-details' />

                        <Grid container className='listing-view-order'>
                            <Typography variant="body2" className='listing-title'>Table</Typography>
                            <Box display="flex" alignItems="center">
                                <img src={table} alt='table' className='orderItem-img' />
                                <Box display="flex" alignItems="center" gap={1}>
                                    {viewOrderData?.tableInfo?.childTables?.length > 0 ? (
                                        <Tooltip
                                            title={
                                                <Box sx={{ p: 1 }}>
                                                    <Typography variant="body2" sx={{ textDecoration: 'underline', color: '#fff', fontWeight: 600, mb: 0.5 }}>
                                                        {viewOrderData?.tableInfo?.table_no}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: '#fff', fontWeight: 600, mb: 0.5 }}>
                                                        Merged with
                                                    </Typography>
                                                    {viewOrderData.tableInfo.childTables.map((child) => (
                                                        <Typography key={child.id} variant="caption" sx={{ display: 'block', color: '#fff', pl: 1 }}>
                                                            • {child.table_no}
                                                        </Typography>
                                                    ))}
                                                </Box>
                                            }
                                            arrow
                                            placement="right"
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#0398DC',
                                                        '& .MuiTooltip-arrow': {
                                                            color: '#0398DC',
                                                        },
                                                    },
                                                },
                                            }}
                                        >
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <Typography variant="body2" className='listing-details' sx={{ fontWeight: 600 }}>
                                                    {viewOrderData?.tableInfo?.table_no}
                                                </Typography>
                                                <Chip
                                                    label={`+${viewOrderData?.tableInfo?.childTables?.length}`}
                                                    size="small"
                                                    sx={{
                                                        height: '24px',
                                                        backgroundColor: '#0398DC',
                                                        color: '#fff',
                                                        fontWeight: 600,
                                                        fontSize: '12px',
                                                        borderRadius: '12px',
                                                        '& .MuiChip-label': { px: 1 }
                                                    }}
                                                />
                                            </Box>
                                        </Tooltip>
                                    ) : (
                                        <Typography variant="body2" className='listing-details'>
                                            {viewOrderData?.tableInfo?.table_no}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                        <Divider className='divider-view-details' />
                    </> : ''
                }

                {/* Total Items */}
                <Grid container className='listing-view-order'>
                    <Typography variant="body2" className='listing-title'>Total Items in Order</Typography>
                    <Box className='d-flex align-items-center'>
                        <img src={orderItems} alt='order' className='orderItem-img' />
                        <Typography variant="body2" className='listing-details'>{totalItemCount} Items</Typography>
                    </Box>
                </Grid>
                <Divider className='divider-view-details' />

                {/* Payment Status */}
                <Grid container className='listing-view-order'>
                    <Typography variant="body2" className='listing-title'>Payment Status</Typography>
                    {/* <Box className='payment-status-order'>Pending</Box> */}
                    <Chip
                        size="small"
                        label={viewOrderData?.payment_status == "unpaid" ? "Pending" : viewOrderData?.payment_status == "part_paid" ? "Partially Paid" : viewOrderData?.payment_status}
                        variant={String(viewOrderData?.payment_status).toLowerCase() === "unpaid" ? "outlined" : "filled"}
                        color={String(viewOrderData?.payment_status).toLowerCase() === "unpaid" ? "error" : "success"}
                        sx={{ borderRadius: '5px !important', textTransform: 'capitalize', padding: '0px 10px', lineHeight: '1.3' }}
                    />
                </Grid>
                <Divider className='divider-view-details' />
                {/* Payment mode */}
                {viewOrderData?.order_type == "delivery" && viewOrderData?.payment_status == "paid" &&
                    <>
                        <Grid container className='listing-view-order'>
                            <Typography variant="body2" className='listing-title'>Payment Mode</Typography>
                            <Typography variant="body2" className='listing-details'>
                                {viewOrderData?.payment_mode}
                            </Typography>
                        </Grid>
                        <Divider className='divider-view-details' />
                    </>
                }

                {/* Order Total */}
                <Grid container className='listing-view-order'>
                    <Box>
                        <Typography variant="body2" className='listing-title'> Order Total &nbsp;
                            <Typography variant="span" color="text.secondary">(Includes tax & discounts)</Typography>
                        </Typography>
                    </Box>
                    <Typography variant="h6" className='listing-details' sx={{ color: `${theme?.palette?.highlight?.main} !important` }}>
                        {/* {formatCurrency(parseFloat(viewOrderData?.total_amount)?.toFixed(2), userData?.vendor?.currency)} */}
                            {formatCurrency(
                            (
                                parseFloat(viewOrderData?.total_amount || 0) +
                                (viewOrderData?.order_type === "delivery" &&
                                parseFloat(viewOrderData?.rider_tip_amount || 0) > 0
                                ? parseFloat(viewOrderData?.rider_tip_amount)
                                : 0)
                            ).toFixed(2),
                            userData?.vendor?.currency
                            )}
                    </Typography>
                </Grid>
            </DialogContent>

            {/* Actions */}
            <DialogActions className='action-view-container' sx={{ py: 3 }}>
                <Button variant="outlined" className='cancel-view-btn' onClick={onClose} sx={{ textTransform: 'none' }}>
                    Close
                </Button>
                <Button className='view-details-order-btn' variant="contained" endIcon={<ArrowForwardIcon />}
                    onClick={() => handleDetails(viewOrderData)}>
                    View Full Details
                </Button>
            </DialogActions>
        </>
    )
}

export default ViewOrderDialogcontainer
